import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { SelectField } from 'shared/controls/select-field';
import { useUsers } from 'shared/queries';
import { Brands } from 'shared/types';

interface SalesRepDropDownProps {
  loggedInUserId: string;
}
export function SalesRepDropDown({ loggedInUserId }: SalesRepDropDownProps) {
  const { brand } = useParams<{ brand: Brands }>();
  const {
    formState: { errors },
  } = useFormContext();

  const { dropdownOptions, isLoading } = useUsers(brand, loggedInUserId);

  return (
    <SelectField
      name='assignedSalesRep'
      label='Assigned Sales Rep'
      rules={{ required: { message: 'Assigned Sales Rep is required', value: true } }}
      error={Boolean(errors?.assignedSalesRep)}
      helperText={errors?.assignedSalesRep?.message}
      options={dropdownOptions}
      getOptionLabel={salesRep => salesRep.key}
      getOptionSelected={(option, value) => {
        if (!option || !value) return true;
        return option.value === value.value;
      }}
      loading={isLoading}
    />
  );
}
